import React, { Component } from 'react'
import ClearCache from 'react-clear-cache'

export default class ClearCacheContainer extends Component {
  render() {
    return (
      <ClearCache duration={60000}>
        {({ isLatestVersion, emptyCacheStorage }) => {
          if (!isLatestVersion) {
            emptyCacheStorage()
          }
          return null
        }}
      </ClearCache>
    )
  }
}
